import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const ScenarioContext = createContext(null);

export function ScenarioProvider({ children }) {
  const { user } = useAuth();
  const [scenarios, setScenarios] = useState([]);
  const [scenario, setScenario] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/scenarios").then(({ data }) => {
      setScenarios(data);
      const saved = localStorage.getItem("evos_scenario");
      const found = data.find((s) => s.id === saved);
      setScenario(found || data[0]);
    }).catch(() => {});
  }, [user]);

  const switchScenario = (id) => {
    const s = scenarios.find((x) => x.id === id);
    if (s) {
      setScenario(s);
      localStorage.setItem("evos_scenario", s.id);
    }
  };

  return (
    <ScenarioContext.Provider value={{ scenarios, scenario, switchScenario }}>
      {children}
    </ScenarioContext.Provider>
  );
}

export const useScenario = () => useContext(ScenarioContext);
